<template>
  <b-card>
    <b-form @reset="resetFilter">
      <fieldset :disabled="isLoadingOrActiveProfileSet">
        <b-form-group id="name-group" :label="$t('name')" label-for="name">
          <b-form-input size="sm" id="name" type="text" v-model="filter.name" v-on:keyup="onkeyup"/>
        </b-form-group>

        <b-form-group id="id-group" :label="$t('organizationNumber')" label-for="id">
          <b-form-input size="sm" id="id" type="text" :disabled=isOrganizationAsActiveProfile(this.activeProfile)
                        v-model="filter.organizationNumber" v-on:keyup="onkeyup"/>
        </b-form-group>

        <b-form-group id="school-group" :label="$t('type')" label-for="school">
          <b-form-select size="sm" id="school" :options="types" v-model="filter.school" v-on:change="updateOrganization">
            <template slot="first">
              <option :value="this.school">{{ $t('school') }}</option>
            </template>
          </b-form-select>
        </b-form-group>

        <b-form-group id="source-group" :label="$t('source')" label-for="source">
          <b-form-select size="sm" id="source" :options="organizationSources" v-model="filter.source" v-on:change="updateOrganization">
            <template slot="first">
              <option :value="null">{{ $t('all') }}</option>
            </template>
          </b-form-select>
        </b-form-group>

        <b-form-group id="active-group" :label="$t('active')" label-for="active">
          <b-form-checkbox size="lg" v-model="filter.isActive" name="checkbox" switch/>
        </b-form-group>

        <b-row>
          <b-col>
            <b-form-select size="sm" id="perPage" v-model="paging.perPage" :options="paging.perPageAlternatives"/>
          </b-col>
          <b-col>
            <b-button size="sm" class="float-right" v-on:click="resetFilter">{{ $t('reset') }}</b-button>
          </b-col>
        </b-row>

        <b-form-group>
          <pagination v-bind:pagination="paging"/>
        </b-form-group>
      </fieldset>
      <b-row>
        <b-col>
          <b-button :disabled="isLoadingOrActiveProfileSet" type="button" block variant="primary" @click="showCreateOrganizationModal">
            {{ $t('createOrganization') }}
          </b-button>
          <create-organization-modal ref="createOrganizationModal"/>
        </b-col>
      </b-row>
    </b-form>
  </b-card>
</template>

<script>
  import { mapGetters } from 'vuex'
  import CreateOrganizationModal from './CreateOrganizationModal'
  import BaseComponent from '../../components/BaseComponent'

  export default {
    name: 'OrganizationFilter',
    extends: BaseComponent,
    components: {
      CreateOrganizationModal
    },
    data () {
      return {
        school: 'School',
        source: 'All'
      }
    },
    computed: {
      ...mapGetters('organizations', ['filter', 'loading', 'paging', 'disableFilters']),
      ...mapGetters('sessionStorage', ['isActiveProfileSet', 'activeProfile']),
      types () {
        return [
          { value: 'SchoolOwner', text: this.$t('schoolOwner') },
          { value: 'All', text: this.$t('all') }
        ]
      },
      isLoadingOrActiveProfileSet () {
        return (this.loading === true || this.disableFilters === true)
      }
    },

    methods: {
      onkeyup (event) {
        if (event.which === 13) {
          this.updateOrganization()
        }
      },
      updateOrganization () {
        this.$store.dispatch('organizations/getOrganizations')
      },
      resetFilter () {
        this.$store.dispatch('organizations/resetFilter')
        this.updateOrganization()
      },
      showCreateOrganizationModal () {
        this.$store.dispatch('organizations/resetOrganization')
        this.$root.$emit('bv::show::modal', 'createOrganizationModal')
      }
    },
    watch: {
      'paging.perPage': function () {
        this.updateOrganization()
      },
      'paging.currentPage': function () {
        this.updateOrganization()
      },
      'filter.isActive': function () {
        this.updateOrganization()
      },
      'filter.isSchool': function () {
        this.updateOrganization()
      },
      'isActiveProfileSet': function () {
        this.updateOrganization()
      }
    }
  }
</script>
